<template>
  <div class="success">
    <div class="wrapper">
      <div
        v-bind:key="index"
        :class="`confetti-${index}`"
        v-for="(confetti, index) in confettis"
      ></div>
    </div>
    <h1 v-bg-typography="'h1'">Create Test</h1>
    <div class="success-text">
      Congratulations! 🙌 You have successfully submitted a new test. You will
      be contacted shortly by our team!
    </div>
  </div>
</template>

<style lang="scss" scoped>
.success-text {
  font-size: 28px;
}
.wrapper {
  position: absolute;
  width: 100%;
  min-height: 100vh;
  top: 0;
  left: 0;
  overflow: hidden;
}

[class|="confetti"] {
  position: absolute;
}

$colors: (#ff00a9, #1821f0, #00deab);

@for $i from 0 through 300 {
  $w: random(50) + 5;
  $l: random(100)-10;
  .confetti-#{$i} {
    width: #{$w}px;
    height: #{$w * 0.4}px;
    background-color: nth($colors, random(3));
    top: -10%;
    left: unquote($l + "%");
    opacity: random() + 0.5;
    transform: rotate(#{random() * 360}deg);
    animation: drop-#{$i}
      unquote(6 + random() + "s")
      unquote(random(100) / 100 + "s");
  }

  @keyframes drop-#{$i} {
    100% {
      top: 110%;
      left: unquote($l + random(15) + "%");
    }
  }
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
export default {
  name: "success",
  directives: {
    BgTypography,
  },
  data() {
    return {
      confettis: Array(300).fill(0),
    };
  },
  mounted() {
    this.$store.dispatch("fetchAllTests");
  },
};
</script>
